import { departmentDashboard } from '../../actions/constant';

const { GET_DEPARTMENT_THERAPY_MIN_FAILURE, GET_DEPARTMENT_THERAPY_MIN_SUCCESS } =
  departmentDashboard;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const getDepartmentTherapyMinReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DEPARTMENT_THERAPY_MIN_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
      };
    }

    case GET_DEPARTMENT_THERAPY_MIN_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
